module.exports = __webpack_public_path__ + "img/valvula.2345334e.svg";